const CaptureGuide = () => {
  return (
    <main className="min-h-screen bg-background">
      <div className="container mx-auto max-w-3xl px-6 py-16">
        <h1 className="text-4xl font-serif mb-4">How to capture photos</h1>
        <p className="text-muted-foreground">
          Stub — full guide content lands in the next step.
        </p>
      </div>
    </main>
  );
};

export default CaptureGuide;
